/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InformationExtractionField } from './InformationExtractionField';
import {
  InformationExtractionFieldFromJSON,
  InformationExtractionFieldFromJSONTyped,
  InformationExtractionFieldToJSON,
} from './InformationExtractionField';

/**
 * Read serializer with fully nested fields.
 * @export
 * @interface InformationExtractionSchemaDetail
 */
export interface InformationExtractionSchemaDetail {
  /**
   *
   * @type {number}
   * @memberof InformationExtractionSchemaDetail
   */
  readonly id: number;
  /**
   *
   * @type {Array<InformationExtractionField>}
   * @memberof InformationExtractionSchemaDetail
   */
  readonly fields: Array<InformationExtractionField>;
}

/**
 * Check if a given object implements the InformationExtractionSchemaDetail interface.
 */
export function instanceOfInformationExtractionSchemaDetail(value: object): value is InformationExtractionSchemaDetail {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('fields' in value) || value['fields'] === undefined) return false;
  return true;
}

export function InformationExtractionSchemaDetailFromJSON(json: any): InformationExtractionSchemaDetail {
  return InformationExtractionSchemaDetailFromJSONTyped(json, false);
}

export function InformationExtractionSchemaDetailFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): InformationExtractionSchemaDetail {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    fields: (json['fields'] as Array<any>).map(InformationExtractionFieldFromJSON),
  };
}

export function InformationExtractionSchemaDetailToJSON(
  value?: Omit<InformationExtractionSchemaDetail, 'id' | 'fields'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {};
}
